import React from 'react'
import './Herosection.css'
import a from '../assets/images/m.jpg'
import b from '../assets/images/f.jpg'
import c from '../assets/images/o.jpg'

import d from '../assets/images/a.jpg'
import e from '../assets/images/i.jpg'
import f from '../assets/images/s.jpg'

const Herosection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        {/* Left side images */}
        <div className="hero-images-left">
          <img src={a} alt="Event" className="hero-img img-1" />
          <img src={b} alt="Event" className="hero-img img-2" />
          <img src={c} alt="Event" className="hero-img img-3" />
        </div>

        {/* Center content */}
        <div className="hero-content">
          <div className="hero-badge">A Singles Mixer</div>
          
          <h1 className="hero-title">
            Mulaqaat<br />
            <span className="hero-subtitle">by The Event House</span>
          </h1>
          
          <p className="hero-description">
            Step away from dating apps and into real conversations.<br /> 
            Mulaqaat is a thoughtfully curated singles mixer designed for meaningful 
            interactions, shared experiences, and genuine <br /> connections — all in a 
            relaxed, premium setting.
          </p>
          
          <div className="hero-buttons">
            <a href="/events" className="hero-btn btn-primary">
              Book Your Slot Now
            </a>
            <a href="/#about" className="hero-btn btn-secondary">
              Know More About Mulaqaat
            </a>
          </div>
          
          <p className="hero-tagline">
            No pressure. No awkwardness.<br />
            Just people, conversations, and moments that feel real.
          </p>
        </div>

        {/* Right side images */}
        <div className="hero-images-right">
          <img src={d} alt="Event" className="hero-img img-4" />
          <img src={e} alt="Event" className="hero-img img-5" />
          <img src={f} alt="Event" className="hero-img img-6" />
        </div>
      </div>
    </section>
  )
}

export default Herosection
